import { render, staticRenderFns } from "./MergeRuleManagement.vue?vue&type=template&id=d85b6636&scoped=true"
import script from "./MergeRuleManagement.vue?vue&type=script&lang=js"
export * from "./MergeRuleManagement.vue?vue&type=script&lang=js"
import style0 from "./MergeRuleManagement.vue?vue&type=style&index=0&id=d85b6636&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d85b6636",
  null
  
)

export default component.exports